// @flow

import React, { Component, useState, useEffect, useRef } from "react";
import Map from "ol/Map";
import { fromLonLat } from "ol/proj";
import View from "ol/View";
import TileLayer from "ol/layer/Tile";
import OSM from "ol/source/OSM";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import CustomLayer from "./layer";
import ControlSelected from "./selectedResourceOverlay";
import PaletteOverlay from "./paletteOverlay";

type LonLat = {
  lon: number,
  lat: number
};

type VectorLayerProps = {
  id: string,
  url: string
};

type Props = {
  center: LonLat,
  zoom: number,
  vectorLayers: Array<VectorLayerProps>
};

type State = {
  map: any
};

const ReactMap = props => {
  const mapEl = useRef(null);
  const [map, setMap] = useState(null);
  useEffect(
    () => {
      const { center, zoom } = props;

      const lonLatRefer = fromLonLat([center.lon, center.lat]);
      let mapInstance = map;
      if (mapInstance === null) {
        mapInstance = new Map({
          view: new View({
            center: lonLatRefer,
            zoom: zoom,
            maxZoom: 17
          }),
          layers: [
            new TileLayer({
              source: new OSM()
            })
          ],
          target: mapEl.current
        });
        setMap(mapInstance);
      }
    },
    [props.vectorLayers]
  );

  const { availHeight } = window.screen;
  const height = availHeight - 300;
  const layers = props.vectorLayers.map(layer => {
    return (
      <React.Fragment key={layer.id}>
        {<CustomLayer map={map} data={layer} renderedLayers={layers} />}
        {/*<D3Layer map={this.state.map} data={layer} />*/}
      </React.Fragment>
    );
  });
  const elements = (
    <React.Fragment>
      {layers}
      <ControlSelected map={map} />
      <PaletteOverlay map={map} />
    </React.Fragment>
  );
  return (
    <div ref={mapEl} style={{ position: "relative", height, width: "100%" }}>
      {map ? elements : null}
    </div>
  );
};

class MapController extends Component<Props, State> {
  mapRef = React.createRef();

  state = {
    map: null
  };

  componentDidMount() {
    const { center, zoom } = this.props;

    const lonLatRefer = fromLonLat([center.lon, center.lat]);

    const map = new Map({
      view: new View({
        center: lonLatRefer,
        zoom: zoom,
        maxZoom: 17
      }),
      layers: [
        new TileLayer({
          source: new OSM()
        })
      ],
      target: this.mapRef.current
    });

    this.setState({
      map
    });
  }

  render() {
    const { availHeight } = window.screen;
    const height = availHeight - 300;
    const layers = this.props.vectorLayers.map(layer => {
      return (
        <React.Fragment key={layer.id}>
          {<CustomLayer map={this.state.map} data={layer} />}
          {/*<D3Layer map={this.state.map} data={layer} />*/}
        </React.Fragment>
      );
    });
    const elements = (
      <React.Fragment>
        {layers}
        <ControlSelected map={this.state.map} />
        <PaletteOverlay map={this.state.map} />
      </React.Fragment>
    );
    return (
      <div
        ref={this.mapRef}
        style={{ position: "relative", height, width: "100%" }}
      >
        {this.state.map ? elements : null}
      </div>
    );
  }
}

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReactMap);



// WEBPACK FOOTER //
// ./src/components/map/index.js